export default "__VITE_ASSET__CINlE0aF__"